<template lang="pug">
    .preorder-columns(:class="{ signin: !token }")
        .column.left
            .perfect-scrollbar
                slot(name="header")
                //- main.info
                //-     .section(
                //-         v-if="shopSections.length && token"
                //-         v-for="(section, index) in shopSections"
                //-         :key="section.id"
                //-         :class="section.key"
                //-     )
                .main-menu
                    slot(name="menu")
                .shop-menu-root
                    tree-menu.main-shop-menu(:items="items" :active-ids="activeMenuItemIDs" :max-depth="1" :delay="400")
                main.contentpage
                    Authenticate(defaultTab="signin" :registration="false")
                        .shop-menu-first-level(v-if="firstLevelItems && firstLevelItems.length")
                            tree-menu(
                                :items="firstLevelItems"
                                :active-ids="activeMenuItemIDs"
                                :max-depth="1"
                                :delay="400"
                            )
                        .sections(v-if="mainSections.length")
                            .section.mb-6(v-for="(section, index) in mainSections" :key="section.id" :class="section.key")
                                Heading(v-if="section.key === 'heading'" :section="section")
                                Post(v-if="section.key === 'post'" :section="section")
                                ArticleList(v-if="section.key === 'categoryproducts'" :section="section")
            CartRow
        .column.right
            main.addition
                Video(v-if="currentVideo" :video="currentVideo" @ended="focusFirstImage")
                Graphic(v-else-if="currentImage" :image="currentImage" :title="currentProduct.name")
            slot(name="footer")
</template>

<script>

import _ from 'lodash'
import { mapGetters, mapMutations, mapActions } from 'vuex'

import Authenticate from '@/components/Authenticate'
import NestedSet from '@/nested-set-lib'

import Post from '@/components/Post'
import Heading from '@/components/Heading'

import ArticleList from '@/extensions/shop/components/ArticleList'
import CartRow from '@/extensions/shop/components/CartRow'
import Video from '@/extensions/shop/components/Video'
import Graphic from '@/extensions/shop/components/Graphic'

import router from '@/router'

export default {
    name: 'Preorder',
    components: {
        Post,
        Heading,
        ArticleList,
        Authenticate,
        Video,
        Graphic,
        CartRow
    },
    computed: {
        currentProduct() {
            if (this.focusedMedia && this.focusedMedia.product) return this.focusedMedia.product
            return this.activeProduct
        },
        currentVideo() {
            let video
            if (this.focusedMedia) {
                if (this.focusedMedia.type === 'video') video = this.focusedMedia.video
            } else if (this.activeProduct && this.activeProduct.media && this.activeProduct.media.length) {
                const media = this.activeProduct.media.find(media => media.type === 'video' && media.video !== null)
                if (media) video = media.video
            }
            return video
        },
        currentImage() {
            let image
            if (this.focusedMedia) {
                if (this.focusedMedia.type === 'image') image = this.focusedMedia.image
            } else if (this.activeProduct && this.activeProduct.media && this.activeProduct.media.length) {
                let media = this.activeProduct.media.filter(media => media.type === 'image' && media.image !== null)
                if (media && media.length) {
                    media = _.orderBy(media, 'position')
                    image = media[0].image
                }
            }
            return image
        },
        mainSections() {
            return this.sections.filter(section => {
                return section.area === 'main' && (section.key === 'heading' || section.key === 'post' || section.key === 'categoryproducts')
            })
        },
        // shopSections() {
        //     return this.sections.filter(section => {
        //         return section.area === 'shoppinginfo' && section.key === 'videostreaming'
        //     })
        // },
        cartHasItems() {
            if ( this.cart && this.cart.qty ) return true
            return false
        },
        categoryItems() {
            let items = _.cloneDeep(this.categories)

            if (items.length) {
                return NestedSet.createTree(items)
            }

            return null
        },
        items() {
            let items = []

            const menu = this.menus.find(menu => menu.key === 'shop-menu')
            items = _.get(menu, 'menuItems') || []
            items = _.cloneDeep(items)

            if (items.length) {
                return NestedSet.createTree(items)
            }
        },
        firstLevelItems() {
            let tree

            if (this.activeMenuItemIDs && this.activeMenuItemIDs.length) {
                const rootID = this.activeMenuItemIDs[0]

                let items = []
                const menu = this.menus.find(menu => menu.key === 'shop-menu')
                items = _.get(menu, 'menuItems') || []
                items = _.cloneDeep(items)

                if (items.length) {
                    const full = NestedSet.createTree(items)
                    if (full && full.length) {
                        const item = full.find(el => el.id === rootID)
                        if (item && item.children && item.children.length) tree = item.children
                    }
                }
            }

            return tree
        },
        activeMenuItemIDs() {
            let IDs = [];

            const menus = this.menus || [];
            const menu = menus.find(menu => menu.key === 'shop-menu');
            const items = _.get(menu, 'menuItems') || [];

            const path = this.$route.path;
            const item = items.find(el => el.path === path);

            if (item) {
                const ancestors = NestedSet.getAncestors(_.cloneDeep(items), item);
                IDs = _.map([...ancestors, item], 'id');
            }

            return IDs;
        },
        ...mapGetters({
            sections: 'currentPage/sections',
            parent: 'currentPage/parent',
            menus: 'menus',
            cart: 'shop/cart',
            token: 'auth/token',
            activeProduct: 'shop/activeProduct',
            focusedMedia: 'shop/focusedMedia',
            categories: 'shop/categories',
        }),
    },
    methods: {
        ...mapMutations({
            setFocusedMedia: 'shop/setFocusedMedia',
            removeFocusedMedia: 'shop/removeFocusedMedia'
        }),
        focusFirstImage() {
            if (this.activeProduct && this.activeProduct.id === this.currentProduct.id && this.activeProduct.media && this.activeProduct.media.length) {
                let media = this.activeProduct.media.filter(media => media.type === 'image' && media.image !== null)
                if (media && media.length) {
                    media = _.orderBy(media, 'position')
                    this.setFocusedMedia({ product: this.activeProduct, media: media[0] });
                }
            }
        },
    },
    mounted() {
    }
}
</script>
<style lang="sass" scoped>

@import "~@/assets/sass/variables";
@import "~bulma/sass/utilities/mixins";

ul.main-shop-menu
    display: flex !important
    flex-direction: row
    &::v-deep > li + li
        margin-left: 10px !important
    +mobile
        flex-direction: column
        &::v-deep > li + li
            margin-top: 10px !important
            margin-left: 0! important
main.info
    flex-direction: row !important
.videostreaming
    width: 32px !important
    float: left
span.icon
    float: left
.slide-container
    position: relative
    button.close-slide-container
        display: none
        z-index: 2
        +desktop
            display: initial
            position: absolute
            background: none
            border: 1px solid
            color: inherit
            font-size: 1rem
            top: 10px
            left: 0
            width: 20px
            height: 24px
            padding: 0
            border-radius: $radius-small
            cursor: pointer
.preorder-columns
    // .left
    .right
        display: none
        +desktop
            position: relative
            background: #ededed
            display: flex
            ::v-deep
                nav#footer-menu
                    bottom: 20px
                // .video
            .addition
                top: 0
                right: 0
                height: calc(100vh - 65px)
                width: calc((100vh - 65px) * (9 / 16))
                position: fixed
    .contentpage > .member
        display: flex
        .shop-menu-first-level
            padding-right: 2rem
    // &.signin
    //     display: block
    //     .right
    //         display: none
    //     .left
    //         width: 50vw
    //         .authentication-form
    //             width: 400px !important
.shop-menu-root,
.shop-menu-first-level
    padding: 0 5rem
    padding-top: 2rem
    & > ul.tree-menu
        display: block
        &::v-deep > li
            width: 100%
            max-width: 250px
            & > .tree-item > a
                padding: 12px 24px
                border: 1px solid black
                display: inline-block
                width: 100%
                text-align: center
                text-transform: uppercase
                // font-weight: bold
                transform: background .15s ease, color .15s ease
            &.active > .tree-item > a
                color: white !important
                background: black
    +mobile
        padding-left: 10px
    +tablet-only
        padding-left: 10px
.shop-menu-first-level
    padding: 0
    & > ul.tree-menu
        &::v-deep > li
            margin-bottom: 6px
            & > .tree-item > a
                min-width: 60px
                padding: 6px 12px
.section.categoryproducts
    width: 100%
.sections
    width: 100%
    .section + .section
        margin-top: 2rem
</style>
